import React from 'react';
import PropTypes from 'prop-types';
import { Spin, Row, Col } from 'antd';
import ReduxElencoAttivita from 'containers/fe/ReduxElencoAttivita.jsx';
import ReduxRegistroAbsences from 'containers/fe/ReduxRegistroAbsence.jsx';
import ReduxRegistroSummary from 'containers/fe/ReduxRegistroSummary.jsx';
import ReduxRegistroStatus from 'containers/fe/ReduxRegistroStatus.jsx';
import ReduxHoursCounter from 'containers/fe/ReduxHoursCounter.jsx';
import ReduxRegistroActions from 'containers/fe/ReduxRegistroActions.jsx';
import ReduxRegistroProgram from 'containers/fe/ReduxRegistroProgram.jsx';
import ReduxRegistroNotes from 'containers/fe/ReduxRegistroNotes.jsx';

function Registro({ isLoaded, isEditing, isSaving }) {
  const isLoading = !isLoaded;
  return (
    <div>
      <Spin
        spinning={isLoading || isEditing || isSaving}
        tip="Caricamento..."
      >
        <Row gutter={16}>
          <Col span={19}>
            <Row className="vmg10" gutter={16}>
              <Col span={8}>
                <ReduxHoursCounter ctx="activity"/>
              </Col>
              <Col span={8}>
                <ReduxHoursCounter ctx="absence" />
              </Col>
              <Col span={8}>
                <ReduxRegistroStatus />
              </Col>
            </Row>
            <Row className="vmg10" gutter={16}>
              <Col span={7}>
                <ReduxRegistroActions />
              </Col>
              <Col span={17}>
                <ReduxRegistroNotes />
              </Col>
            </Row>
            
            <ReduxRegistroAbsences />
            <ReduxElencoAttivita />
          </Col>
          <Col span={5}>
            <ReduxRegistroSummary />
            <ReduxRegistroProgram />
          </Col>
        </Row>
      </Spin>
    </div>
  );
}

Registro.propTypes = {
  isLoaded: PropTypes.bool,
  isEditing: PropTypes.bool,
  isSaving: PropTypes.bool,
};

export { Registro };
